export type OnboardingWizardStepId =
  | 'business-type'
  | 'gastronomy-stock-mode'
  | 'other-rubro'
  | 'identity';

export type OnboardingWizardStepDef = {
  id: OnboardingWizardStepId;
  label: string;
  title: string;
  subtitle?: string;
  eyebrow: string;
};

/** @deprecated Pack step removed from alta (proto v2). Kept for type compat in tests. */
export type CatalogSeedMode = 'empty' | 'pack';

const STEP_BUSINESS_TYPE: OnboardingWizardStepDef = {
  id: 'business-type',
  label: 'Qué vendés',
  title: '¿Qué vendés?',
  subtitle: 'Elegí lo más parecido. Después afinamos con lo que uses.',
  eyebrow: 'Paso 1',
};

const STEP_OTHER_RUBRO: OnboardingWizardStepDef = {
  id: 'other-rubro',
  label: 'Detalle',
  title: 'Contanos tu rubro',
  subtitle: 'Escribí qué vendés y marcá lo que usás en el local.',
  eyebrow: 'Otros',
};

const STEP_GASTRONOMY_STOCK: OnboardingWizardStepDef = {
  id: 'gastronomy-stock-mode',
  label: 'Stock',
  title: '¿Cómo llevás stock?',
  subtitle: 'Elegí cómo querés cargar cantidades. Después lo podés cambiar en Funciones del negocio.',
  eyebrow: 'Gastronomía',
};

const STEP_IDENTITY: OnboardingWizardStepDef = {
  id: 'identity',
  label: 'Nombre del local',
  title: '¿Cómo se llama tu local?',
  subtitle: 'Escribí el nombre de tu local. Así te ven vos y tus clientes.',
  eyebrow: 'Paso 2',
};

export function getOrganizationSetupSteps(
  multiBusinessEnabled: boolean,
  options?: {
    includeOtherRubroStep?: boolean;
    includeQsfFlavorStep?: boolean;
    includeGastronomyStockStep?: boolean;
  },
): OnboardingWizardStepDef[] {
  // includeQsfFlavorStep ignored — flavors are tiles in the rubro picker (proto v2).
  void options?.includeQsfFlavorStep;
  if (multiBusinessEnabled) {
    const afterBusinessType: OnboardingWizardStepDef[] = [];
    if (options?.includeOtherRubroStep) {
      afterBusinessType.push(STEP_OTHER_RUBRO);
    } else if (options?.includeGastronomyStockStep) {
      afterBusinessType.push(STEP_GASTRONOMY_STOCK);
    }
    return [STEP_BUSINESS_TYPE, ...afterBusinessType, STEP_IDENTITY];
  }
  return [STEP_IDENTITY];
}
